import { Link } from "react-router-dom";
// import axios from 'axios';
// import { useState,useEffect } from 'react';
import { useBlogHeader } from "../../../hooks/apis/headers";

function Blog_header() {
  const { data: blogData, isLoading, error } = useBlogHeader();

  // const[blogTitle,setblogTitle] = useState('');

  // useEffect(() => {
  //     axios.get('https://panel.baghban.restaurant/api/header/blog')
  //         .then(response => {
  //             setblogTitle(response.data.title);
  //             // setslideText(response.data.spotlites[0].text);
  //             console.log(response.data);
  //         })
  //         .catch(error => {
  //             console.error(error);
  //         });
  // }, []);

  if (isLoading)
    return (
      <div className={isLoading ? "active loading" : "loading"}>
        <img src="/images/loading.svg" className="img-fluid" alt="loading" />
      </div>
    );
  if (error) return <p>Error</p>;

  return (
    <div className="blog-header">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>{blogData.title}</h1>
            <div className="breadcrumbs">
              <Link to="/">صفحه اصلی</Link>
              <i className="fas fa-angle-left"></i>
              <span className="current-page">وبلاگ</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog_header;
